<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Xem chi tiết kết quả xử lý đã gửi lên</strong>
                    </div>
                    <div class="document-view">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Số QĐ phê duyệt PAXL:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetHandlingDecisions.decisionNumber" :title="assetHandlingDecisions.decisionNumber" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Ngày QĐ phê duyệt PAXL: "
                                              label-for="unit"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetHandlingDecisions.decisionDate | formatDate" :title="assetHandlingDecisions.decisionDate | formatDate
                                                  " :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Chức danh người QĐ:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetHandlingDecisions.deciderTitle" :title="assetHandlingDecisions.deciderTitle" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Thuộc Bộ/ Tỉnh:"
                                              label-for="region"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="assetHandlingDecisions.issuedUnitName" :title="assetHandlingDecisions.issuedUnitName" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :dataUrl="gridUrl"
                            gridName="Danh sách tài sản"
                            ref="assetDecision">
                        <template v-slot:cell(handlingCalculationUnitValue)="row">
                            {{ row.item.handlingCalculationUnitValue | formatNumber }} {{row.item.handlingCalculationUnitType || '' }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewAssetExploitationDocument'])"
                                          @click="showAssetDetail(row.item, row.index, $event.target)"
                                          size="sm" title="Xem" variant="info">
                                    Xem
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                    <b-row class="justify-content-center">
                        <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-modal :no-enforce-focus="true" :id="infoModal.id" :title="infoModal.title" size="xl">
            <div class="document-view">
                <b-row>
                    <b-col sm="6">
                        <b-form-group label="Mã tài sản tại PM nghiệp vụ:"
                                      label-for="input-unit"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="assetInfo.assetSyncId" :title="assetInfo.assetSyncId" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Mã tài sản tại kho:"
                                      label-for="input-unit"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="assetInfo.assetCode" :title="assetInfo.assetCode" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên tài sản:"
                                      label-for="input-unit"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="assetInfo.assetName" :title="assetInfo.assetName" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Tên loại tài sản:"
                                      label-for="input-unit"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="assetInfo.assetTypeName" :title="assetInfo.assetTypeName" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="SL/ KL/ DT xử lý:"
                                      label-for="input-unit"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="`${assetInfo.handlingCalculationUnitValue | formatNumber} ${assetInfo.handlingCalculationUnitType || ''}`"
                                          :title="`${assetInfo.handlingCalculationUnitValue | formatNumber} ${assetInfo.handlingCalculationUnitType || ''}`" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Nguồn gốc:"
                                      label-for="input-unit"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="assetInfo.assetSourceName" :title="assetInfo.assetSourceName" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Phương án xử lý:"
                                      label-for="input-unit"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="assetInfo.handlingMethodName" :title="assetInfo.handlingMethodName" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label="Hình thức xử lý:"
                                      label-for="input-unit"
                                      :label-cols="4"
                                      :horizontal="true"
                                      label-align="left">
                            <b-form-input :value="assetInfo.handlingFormName" :title="assetInfo.handlingFormName" :readonly="true"></b-form-input>
                        </b-form-group>
                    </b-col>


                    <template v-if="assetInfo.handlingFormCode == handling_form_DC">
                        <b-col sm="6">
                            <b-form-group label="Đơn vị nhận điều chuyển:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.tranferUnitName" :title="assetInfo.tranferUnitName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ngày bàn giao /tiếp nhận:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.tranferDate | formatDate" :title="assetInfo.tranferDate | formatDate" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ghi chú:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <input-auto-size :value="assetInfo.note" :title="assetInfo.note"></input-auto-size>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Giá trị tài sản tại phương án xử lý:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetValue | currency" :title="assetInfo.assetValue | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </template>
                    <template v-if="assetInfo.handlingFormCode == handling_form_BAN">
                        <b-col sm="6">
                            <b-form-group label="Số hợp đồng:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.contractNumber" :title="assetInfo.contractNumber" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ngày hợp đồng:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.contractDate | formatDate" :title="assetInfo.contractDate | formatDate" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Số tiền thu được từ xử lý:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.valueObtained | currency" :title="assetInfo.valueObtained | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Số tiền nộp tài khoản tạm giữ:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.valueInCustody | currency" :title="assetInfo.valueInCustody | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Đơn vị mua được:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.contractPartner" :title="assetInfo.contractPartner" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Số hóa đơn:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.documentNumber" :title="assetInfo.documentNumber" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ngày hóa đơn:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.documentDate | formatDate" :title="assetInfo.documentDate | formatDate" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ngày hoàn thành xử lý:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.documentDate | formatDate" :title="assetInfo.documentDate | formatDate" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Giá trị tài sản tại phương án xử lý:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetValue | currency " :title="assetInfo.assetValue | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ghi chú:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <input-auto-size :value="assetInfo.note" :title="assetInfo.note"></input-auto-size>
                            </b-form-group>
                        </b-col>
                    </template>
                    <template v-if="assetInfo.handlingFormCode == handling_form_DN || assetInfo.handlingFormCode == handling_form_CN">
                        <b-col sm="6">
                            <b-form-group label="Đơn vị nhận bàn giao:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.tranferUnitName" :title="assetInfo.tranferUnitName" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ngày bàn giao /tiếp nhận:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.tranferDate | formatDate" :title="assetInfo.tranferDate | formatDate" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ghi chú:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <input-auto-size :value="assetInfo.note" :title="assetInfo.note"></input-auto-size>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Giá trị tài sản tại phương án xử lý:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetValue | currency" :title="assetInfo.assetValue | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </template>
                    <template v-if="assetInfo.handlingFormCode == handling_form_TH">
                        <b-col sm="6">
                            <b-form-group label="Ngày hoàn thành xử lý"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.handlingDate | formatDate" :title="assetInfo.handlingDate | formatDate" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ghi chú:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <input-auto-size :value="assetInfo.note" :title="assetInfo.note"></input-auto-size>
                            </b-form-group>
                        </b-col>
                    </template>
                    <template v-if="assetInfo.handlingFormCode == handling_form_NSNN">
                        <b-col sm="6">
                            <b-form-group label="Số tiền nộp NSNN:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.valueToBudget | currency" :title="assetInfo.valueToBudget | currency" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ngày hoàn thành xử lý"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.handlingDate | formatDate" :title="assetInfo.handlingDate | formatDate" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Ghi chú:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <input-auto-size :value="assetInfo.note" :title="assetInfo.note"></input-auto-size>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group label="Giá trị tài sản tại phương án xử lý:"
                                          label-for="input-unit"
                                          :label-cols="4"
                                          :horizontal="true"
                                          label-align="left">
                                <b-form-input :value="assetInfo.assetValue" :title="assetInfo.assetValue" :readonly="true"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </template>

                </b-row>
            </div>

            <template #modal-footer="{ ok, cancel, hide }">
                <b-button type="button" variant="primary" @click="hideModal(infoModal.id)">
                    Đóng
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'NationalPublicAssetHandlingDetail',
        mixins: [mixins],
        data() {
            return {
                handling_form_DC: 'DC',//điều chuyển
                handling_form_BAN: 'BAN',//bán
                handling_form_CN: 'CN',//Giao tài sản cho đơn vị chuyên ngành
                handling_form_DN: 'DN',//Giao cho doanh nghiệp ghi tăng vốn nhà nước
                handling_form_TH: 'TH',//Tiêu hủy
                handling_form_NSNN: 'NSNN',//Nộp ngân sách nhà nước
                infoModal: {
                    id: 'detail-result-handling-asset-modal',
                    title: '',
                    content: ''
                },
                gridUrl: 'data/handling-decisions-asset/' + this.$route.params.handlingDecisionId,
                searchForm: {
                    filter: null
                },
                gridOptions: {
                    fields: [
                        { key: 'assetSyncId', label: 'Mã tài sản tại PM nghiệp vụ', sortable: true },
                        { key: 'assetCode', label: 'Mã tài sản tại kho', sortable: true },
                        { key: 'assetName', label: 'Tên tài sản', sortable: true },
                        { key: 'handlingCalculationUnitValue', label: 'SL/ KL/ DT xử lý', sortable: true, tdClass: 'text-right' },
                        { key: 'handlingMethodName', label: 'Phương án xử lý', sortable: true },
                        { key: 'handlingFormName', label: 'Hình thức xử lý', sortable: true },
                    ],
                    sortBy: 'assetName',
                },
                assetHandlingDecisions: {},
                assetInfo: {}
            }
        },
        computed: {
            handlingDecisionId() {
                return this.$route.params.handlingDecisionId;
            }
        },
        created() {
            this.loadConfiscateDecisionsDetail();
        },
        methods: {
            hideModal(id) {
                this.$root.$emit('bv::hide::modal', id)
            },
            showAssetDetail(item, index, button) {
                this.loadAsssetInfo(item.id);
                this.infoModal.title = `Xem chi tiết kết quả xử lý tài sản`;
                this.infoModal.content = item.errorMessage;
                this.$root.$emit('bv::show::modal', this.infoModal.id, button);
            },
            loadAsssetInfo(assetId) {
                var vm = this;
                return this.$services.get(`data/handling-decision-asset-detail/${assetId}`).done(data => {
                    vm.assetInfo = data;
                });
            },
            loadConfiscateDecisionsDetail() {
                var vm = this;
                return this.$services.get(`data/national-public-asset-handlings/${this.handlingDecisionId}`).done(data => {
                    vm.assetHandlingDecisions = data;
                });
            },
            formatArea(val) {
                return this.$options.filters.formatNumber(val) + ' m²';
            },
            formatVolume(val) {
                return this.$options.filters.formatNumber(val) + ' g';
            }
        },
        watch: {
            confiscateDecisionId() {
                return this.$route.params.confiscateDecisionId;
            }
        }
    }
</script>
<style scoped>
    ul {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }
</style>
